import { trackEvent } from '../../../../Assets/helpers/tracking/track.js';
import digitalDataProduct from '../../../../Assets/helpers/tracking/digital-data-product.js';
import getClosestComponentID from '../../../../Assets/helpers/tracking/get-closest-component-id.js';

// Track quand un produit est ajouté au comparateur
globalThis.addEventListener('compareitem', ({ detail: { items, relatedTarget } }) =>
  trackEvent('compareitem', getClosestComponentID(relatedTarget) ?? 'Toolbar', {
    item: items.map(({ prid, catalog, offer, availability, nature, eqNatures, sellerTypes }) =>
      digitalDataProduct({ prid, catalog, offer, availability, nature, eqNatures, sellerTypes })
    )
  })
);

// Track quand un produit est retiré du comparateur
globalThis.addEventListener('compareitemcancel', ({ detail: { items, relatedTarget } }) =>
  trackEvent('compareitemcancel', getClosestComponentID(relatedTarget) ?? 'CompareBanner', {
    item: items.map(({ prid, catalog, offer, availability, nature, eqNatures, sellerTypes }) =>
      digitalDataProduct({ prid, catalog, offer, availability, nature, eqNatures, sellerTypes })
    )
  })
);
